import { inject } from "mobx-react";
import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import { ThumborStore, AspectRatioEnum } from "stores/thumbor/ThumborStore";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";
import { HotelHeartButton } from "../HotelHeartButton/HotelHeartButton";
import * as React from "react";
import { LazyLoadedImage } from "components/utility/LazyLoadedImage/LazyLoadedImage";
import { AnalyticsStore, RouteStore } from "bernie-core";
import { HotelBadge } from "./HotelBadge/HotelBadge";
import { getThumborizedImage } from "src/components/flexComponents/Hotels/utils/getThumborizedImage";

interface CardMediaOverallInfoProps {
  index: number;
  hotel: Hotel;
  thumbor?: ThumborStore;
  analytics?: AnalyticsStore;
  context: ExtendedContextStore;
  moduleName?: string;
  routeStore?: RouteStore;
  displayBadges?: boolean;
}

/**
 * Represents a {@see HotelCard}'s media (image, carousel, favorite button, etc.)
 */

export const CardMediaOverallInfo: React.FC<CardMediaOverallInfoProps> = inject(
  "thumbor",
  "routeStore",
  "analytics"
)(({ hotel, thumbor, context, moduleName = "hotels", displayBadges }) => {
  const { hotelName } = hotel;

  const hotelImageUrl = getThumborizedImage(hotel, thumbor!, context, {
    mobile: AspectRatioEnum.R_2_1,
    desktop: AspectRatioEnum.R_21_9,
  });

  return (
    <UitkFigure ratio={UitkFigureAspectRatioType.R21_9}>
      <div>
        <LazyLoadedImage src={hotelImageUrl} alt={hotelName} context={context} />
      </div>
      <HotelHeartButton moduleName={moduleName} hotel={hotel} />
      {displayBadges && (
        <HotelBadge
          allInclusiveContent={hotel.allInclusiveContent}
          travelerReviewContent={hotel.travelerReviewContent}
        />
      )}
    </UitkFigure>
  );
});
